import { render } from "./BaseSvgIcon.vue?vue&type=template&id=6424fbce&scoped=true&ts=true"
import script from "./BaseSvgIcon.vue?vue&type=script&lang=ts"
export * from "./BaseSvgIcon.vue?vue&type=script&lang=ts"

import "./BaseSvgIcon.vue?vue&type=style&index=0&id=6424fbce&scoped=true&lang=css"

import exportComponent from "/Users/eiji/workspace/tradelabo/members.tradelabo.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6424fbce"]])

export default __exports__